(()=>{
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  let requestController;
  let closeTimer;
  const root=()=>document.querySelector('[data-fw-collection]');
  const reveal=scope=>{
    if(reduced.matches||!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      for(const entry of entries)if(entry.isIntersecting){entry.target.classList.add('is-revealed');observer.unobserve(entry.target)}
    },{threshold:.08,rootMargin:'0px 0px 30px 0px'});
    scope.querySelectorAll('[data-fw-reveal]').forEach(el=>{
      if(el.getBoundingClientRect().top<innerHeight)return;
      el.classList.add('fw-will-reveal');observer.observe(el);
    });
  };
  const closeDrawer=(immediate=false)=>{
    const drawer=root()?.querySelector('.fw-filter-drawer');
    if(!drawer?.open)return;
    clearTimeout(closeTimer);drawer.classList.remove('is-visible');
    const finish=()=>{drawer.close();document.documentElement.classList.remove('fw-filter-lock');root()?.querySelector('[data-open-filters]')?.focus({preventScroll:true})};
    if(immediate||reduced.matches)finish();else closeTimer=setTimeout(finish,300);
  };
  const init=scope=>{
    const section=scope.matches?.('[data-fw-collection]')?scope:scope.querySelector('[data-fw-collection]');
    if(!section)return;
    section.classList.add('fw-collection-ready');
    const drawer=section.querySelector('.fw-filter-drawer');
    if(drawer){
      drawer.addEventListener('cancel',event=>{event.preventDefault();closeDrawer()});
      drawer.addEventListener('click',event=>{if(event.target===drawer){const r=drawer.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDrawer()}});
    }
    reveal(section);
  };
  const load=async(destination,{push=true,focus='results'}={})=>{
    const current=root();if(!current)return;
    requestController?.abort();requestController=new AbortController();
    const controller=requestController;
    const url=new URL(destination,location.href);url.searchParams.delete('section_id');
    closeDrawer(true);current.setAttribute('aria-busy','true');
    const requestUrl=new URL(url);requestUrl.searchParams.set('section_id',current.dataset.sectionId);
    try{
      const response=await fetch(requestUrl,{signal:controller.signal});
      if(!response.ok)throw new Error('Collection unavailable');
      const html=await response.text();
      const incoming=new DOMParser().parseFromString(html,'text/html').querySelector('[data-fw-collection]');
      if(!incoming)throw new Error('Missing collection');
      const apply=()=>{current.replaceWith(incoming);init(incoming)};
      if(document.startViewTransition&&!reduced.matches){await document.startViewTransition(apply).updateCallbackDone}else apply();
      if(push)history.pushState({fwCollection:true},'',url);
      const status=incoming.querySelector('[data-collection-status]');if(status)status.textContent=incoming.dataset.resultMessage;
      const target=focus==='sort'?incoming.querySelector('[data-collection-sort]'):incoming.querySelector('#FwCollectionResults');
      target?.focus({preventScroll:true});
      if(focus!=='sort')target?.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
    }catch(error){if(error.name!=='AbortError')location.assign(url.href)}
    finally{if(requestController===controller)root()?.removeAttribute('aria-busy')}
  };
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-open-filters]');
    if(open){
      const drawer=root()?.querySelector('.fw-filter-drawer');if(!drawer)return;
      clearTimeout(closeTimer);drawer.showModal();document.documentElement.classList.add('fw-filter-lock');
      requestAnimationFrame(()=>requestAnimationFrame(()=>drawer.classList.add('is-visible')));return;
    }
    if(event.target.closest('[data-close-filters]')){closeDrawer();return}
    const link=event.target.closest('a[data-collection-link]');
    if(link&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey){event.preventDefault();load(link.href)}
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('[data-collection-form]');if(!form)return;
    event.preventDefault();const url=new URL(form.action);
    for(const [key,value] of new FormData(form))if(String(value).trim()!=='')url.searchParams.append(key,value);
    const focused=form.classList.contains('fw-sort-form')?'sort':'results';load(url,{focus:focused});
  });
  document.addEventListener('change',event=>{if(event.target.matches('[data-collection-sort]'))event.target.form.requestSubmit()});
  addEventListener('popstate',()=>{if(root())load(location.href,{push:false})});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',()=>{closeDrawer(true);requestController?.abort()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
})();
